import { type GetServerSideProps } from 'next';

import {
  getPostRequestData,
  TPostRequestParams,
} from '../../../../modules/postRequest';
import { applyCorrelationIdHeader } from '../../../../utils/server/applyCorrelationIdHeader';
import { TLocale } from '../../../../modules/shared/@interfaces';
import { withEnhancedPageHandler } from '../../../../middlewares/withEnhancedPageHandler';
import { RequestTemplateNoPin } from '../../../../templates/Request/RequestTemplateNoPin';
import {
  featureToggleRedirectShopee,
  featureToggleServiceShopee,
  featureToggleShoppeCloseService,
} from '../../../../services/featureFlagService';
import { getShopeeUrlService } from '../../../../services/getShopeeService';

const PostRequest = (props: TPostRequestParams) => {
  return <RequestTemplateNoPin {...props} />;
};

const getServerSidePropsHandler: GetServerSideProps = async ({
  query,
  params,
  locale,
  res,
  req,
}) => {
  const { uuid } = params as { uuid: string };
  const { auth_token, is_app } = query;
  const userToken = auth_token as string;
  const isFromApp = is_app as string;

  if (!uuid) {
    return {
      redirect: {
        destination: '/nao-encontrado',
        permanent: false,
      },
    };
  }

  res.setHeader(
    'Cache-Control',
    'public, s-maxage=10, stale-while-revalidate=59'
  );

  const customHeaders = applyCorrelationIdHeader(req.headers);

  const data = await getPostRequestData({
    locale: locale as TLocale,
    uuid,
    customHeaders,
    userAuthToken: userToken ? userToken : '',
  });

  const orderFromApp = isFromApp === 'true';

  const redirectShopee = await featureToggleRedirectShopee();
  const redirectOnLeadExpress = await featureToggleServiceShopee();
  const redirectOnCloseServiceExpressModal =
    await featureToggleShoppeCloseService();
  const shopeeUrl = await getShopeeUrlService();
  const isApp = isFromApp ? orderFromApp : false;

  return {
    props: {
      ...data,
      uuid,
      redirectOnLeadExpress,
      shopeeUrl,
      userToken: userToken || '',
      redirectOnCloseServiceExpressModal,
      isApp,
      redirectShopee,
    },
  };
};

export const getServerSideProps = withEnhancedPageHandler(
  getServerSidePropsHandler
);

export default PostRequest;
